import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { feedbackListRes, feedbackListTodo } from '../../LMS_Redux/LMS_Slices/Feedback/FeedbackList'
import { PropagateLoader } from 'react-spinners'
import DataTables from '../LMS_DATA_TABLE/DataTable'
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from 'react-tooltip'
import FeedbackDetails from './FeedbackDetails'
import { feedbackDetailsRes, feedbackDetailsTodo } from '../../LMS_Redux/LMS_Slices/Feedback/FeedbackDetails'

export default function FeedbackList() {

    const dispatch = useDispatch()
    const feedback_list = useSelector(state => state.feedbackList && state.feedbackList.data && state.feedbackList.data.data)
    const [loading, setLoading] = useState(false)
    const [detailLoading, setDetailLoading] = useState(true)
    const [detailModal, setDetailModal] = useState(false)
    const [detailModalData, setDetailModalData] = useState()
    // console.log(feedback_list)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'EMPLOYEE',
            field: 'user_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'NAME',
            field: 'course_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'INSTRUCTOR NAME',
            field: 'instructor_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'submitted_date',
            // cellRenderer: params => new Date(params.value).toDateString(),
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline size={20} className='eye'
                        onClick={() => feedback_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Feedback Details!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ])

    const feedback_details = (params) => {
        // console.log(params.data)
        setDetailModalData(params.data)
        setDetailLoading(true)
        setDetailModal(true)
        dispatch(feedbackDetailsTodo({ "user_id": params.data.fk_user_id, "course_id": params.data.course_id, "training_id": params.data.fk_training_id })).then(() => feedback_details_res())
    }

    const feedback_details_res = () => {
        if (feedbackDetailsRes && feedbackDetailsRes.success) {
            setDetailLoading(false)
        } else {
            setDetailLoading(false)
        }
    }

    const feedback_list_res = () => {
        if (feedbackListRes && feedbackListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(feedbackListTodo()).then(() => feedback_list_res())
    }, [])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Feedback Management / </span>
                    <span className='icon2'>Feedback List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    feedback_list && feedback_list.length ?
                        <DataTables
                            rowData={feedback_list}
                            columnDefs={columnDefs}
                        />
                        :
                        <div className='wrapper-admin'>
                            <div className='text-center'>
                                <h5>Feedback List Not Found!!.. </h5>
                            </div>
                        </div>
                }
            </div>

            <FeedbackDetails detailLoading={detailLoading} setDetailLoading={setDetailLoading} detailModal={detailModal} setDetailModal={setDetailModal} detailModalData={detailModalData} setDetailModalData={setDetailModalData} />
        </>
    )
}
